export default "__VITE_ASSET__8c6f68d3__"